import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import AuthUser from "../../services/AuthUser";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import CircularScrollProgress from "../Circularprogress";
import './userFont.css';
import { useNavigate } from "react-router-dom";



const UserInvoices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invoiceHtml, setInvoiceHtml] = useState(""); // Store fetched invoice HTML

       const { http, token } = AuthUser();
   const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setError("User not found.");
      setLoading(false);
      return;
    }


    const email = user?.email || "default@example.com"; // Fallback if email is missing
    const name = user?.name || "Guest"; // Fallback if name is missing

    http.get(`/user-service-details`, { params: { email, name } })
      .then((response) => {
        if (Array.isArray(response.data)) {
          setServices(response.data);
        } else if (response.data?.data) {
          setServices(response.data.data);
        } else {
          setServices([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load services.");
        setLoading(false);
      });
  }, []);


  if (loading) return <p className="text-center">Loading services...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;

  // Define a mapping for services and their respective table keys
  const serviceTableKeys = {
    "Annual Compliance (LLP)": "tblannualcompalinacellp",
    "Annual Compliance (Pvt Ltd)": "tblannualcompalinacepvtltd",
    "One Person Company Registration": "tblopccompanyregistration",
    "Other Services": "tblothers",
    "Partnership Deed": "tblpaternershipdeed",
    "Private Limited Company Registration": "tblpvtltdcompanyregistration",
    "Section Eight Company Registration": "tblsectioneightcompanyregistraion",
    "LLP Registration": "tblllpregistartion",
    "Legal Advice": "tbllegal_advice",
    "Legal Notice Reply": "tbllegalnotice_replay",
    "Legal Notice Preparation": "tbllegalnoticereparation",
    "Food License": "tblfoodlinces",
    "GST Registration": "tblgstregistration",
    "Gumasta License": "tblgumastalicense",
    "IEC (Import Export Code)": "tbliec",
    "MSME Registration": "tblmsmeregitration",
    "Trademark Services": "tbltrademarkservices",
    "Online Accounting": "tblonlineacconting",
    "ITR Filing": "tbliterfiling",
    "GST Return Filing": "tblgstreturnfilling",
    "TDS Return Filing": "tbltdsretrunfiling"
  };

  const fetchInvoiceHtml = async (serviceId, tableKey, serviceName) => {
    const url = `http://127.0.0.1:8000/api/fetch-invoice/${serviceId}/${tableKey}/${encodeURIComponent(serviceName)}`;

    try {
      const response = await fetch(url);
      const html = await response.text(); // Read as plain HTML instead of JSON

      if (!html.includes("<html") && !html.includes("<body")) {
        alert("Failed to load invoice.");
        return;
      }

      console.log("Invoice HTML received:", html);
      downloadInvoice(serviceName, html);
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  };


  const downloadInvoice = (serviceName, htmlContent) => {
    console.log("Opening invoice in a new tab...");

    // Open new tab
    const newTab = window.open("", "_blank");
    if (!newTab) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // **Improved Invoice HTML with Explicit Background & Font Settings**
    const invoiceHtml = `
          <html>
          <head>
              <title>Invoice - ${serviceName}</title>
              <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"></script>
              <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
              <style>
                  * { box-sizing: border-box; margin: 0; padding: 0; }
                  body { 
                      font-family: Arial, sans-serif; 
                      background: #ffffff !important; /* ✅ Fix black background */
                      color: #000; /* ✅ Ensure text is visible */
                      padding: 20px; 
                  }
                  #invoiceContainer { 
                      background: #fff; /* ✅ Ensure white background */
                      padding: 20px; 
                      margin: auto; 
                      width: 80%; 
                      max-width: 800px; 
                      box-shadow: 0 0 10px rgba(0,0,0,0.1);
                      border-radius: 8px;
                      text-align: left;
                  }
                  h2 { text-align: center; margin-bottom: 20px; color: #333; }
                  table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                  th, td { border: 1px solid #ddd; padding: 10px; text-align: left; }
                  th { background: #f8f8f8; }
                  button { 
                      background: #28a745; 
                      color: white; 
                      padding: 10px 20px; 
                      border: none; 
                      cursor: pointer; 
                      margin-top: 20px; 
                      display: block;
                      width: 200px;
                      margin: 20px auto;
                      text-align: center;
                  }
                  button:hover { background: #218838; }
              </style>
          </head>
          <body>
              <div id="invoiceContainer">
                 
                  ${htmlContent}
              </div>
              <button onclick="downloadPdf()">Download PDF</button>
              
              <script>
                  async function loadImages() {
                      const images = document.querySelectorAll("img");
                      const promises = Array.from(images).map(img => new Promise(resolve => {
                          if (img.complete) resolve();
                          img.onload = resolve;
                          img.onerror = resolve;
                      }));
                      await Promise.all(promises);
                      console.log("All images loaded.");
                  }
  
                  async function downloadPdf() {
                      console.log("Starting HTML to canvas conversion...");
                      await loadImages();
  
                      html2canvas(document.getElementById("invoiceContainer"), {
                          useCORS: true,
                          allowTaint: false,
                          scale: 2.5, // ✅ Higher scale for better quality
                          backgroundColor: "#ffffff" // ✅ Ensure proper background
                      }).then(canvas => {
                          console.log("Canvas rendering complete.");
                          const imgData = canvas.toDataURL("image/png");
  
                          // ✅ Use PDF dimensions that fit A4 size
                          const pdf = new jspdf.jsPDF("p", "mm", "a4");
                          const pdfWidth = pdf.internal.pageSize.getWidth();
                          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
                          pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
                          pdf.save("Invoice-${serviceName}.pdf");
                          console.log("PDF saved successfully.");
                      }).catch(error => {
                          console.error("Error generating PDF:", error);
                      });
                  }
              </script>
          </body>
          </html>
      `;

    // Write to the new tab
    newTab.document.open();
    newTab.document.write(invoiceHtml);
    newTab.document.close();
  };




  if (loading) return <p className="text-center">Loading services...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;



  return (
  <div>
     <div className="container mt-4">
      <h2 className="mb-3">My Invoices</h2>

      {/* Invoices List */}
      <div className="row mt-3">
        {services.length > 0 ? (
          services.map((service) => {
            const tableKey = serviceTableKeys[service.service_name] || "default_table";

            return (
              <div key={service.service_id} className="col-md-4 mb-3">
                <Card>
                  <Card.Body>
                    <Card.Title>{service.service_name}</Card.Title>
                    <Card.Text><strong>Date:</strong> {service.created_date}</Card.Text>

                    {/* View Invoice Button */}
                    {/* <Button
                      variant="primary"
                      onClick={() => {
                        const tableKey = serviceTableKeys[service.service_name] || "";
                        if (!tableKey) {
                          alert("Invalid service name");
                          return;
                        }

                        const url = `http://127.0.0.1:8000/view-invoice/${service.service_id}/${tableKey}/${encodeURIComponent(service.service_name)}`;
                        window.open(url, "_blank");
                      }}
                    >
                      View
                    </Button>{' '} */}

                    {/* Download Invoice Button */}

                    <Button
                      variant="primary"
                      onClick={() => fetchInvoiceHtml(service.service_id, tableKey, service.service_name)}
                    >
                      View & Download
                    </Button>

                  </Card.Body>
                </Card>
              </div>
            );
          })
        ) : (
          <p className="text-center">No invoices available.</p>
        )}
      </div>
 
    </div>
    <div className="space40 bg-white"></div>

<WhatsAppScrollButton />
<Footer />
<CircularScrollProgress />
  </div>
  );
};

export default UserInvoices;